import { Table, Tag } from "antd";
import { idToObjectMap, populateKey } from "common/utils";
import { useMemo } from "react";

export function FeePlanRulesTable(props) {
  const { feePlans, rules, productOfferings } = props;

  const productOfferingsById = useMemo(() => {
    return idToObjectMap(productOfferings);
  }, [productOfferings]);

  const columns = [
    {
      title: "Fee Plan Name",
      dataIndex: "feePlan",
      key: "feePlan",
      render: (index, rule) =>
        feePlans?.find((feePlan) => feePlan.id === rule.feePlanId)?.name ??
        `Fee Plan #${rule.feePlanId}`,
    },
    {
      title: "Legal Status",
      dataIndex: "legalStatuses",
      key: "legalStatuses",
      render: (index, rule) =>
        rule.legalStatuses?.map(
          (status) =>
            ({
              in_litigation: (
                <Tag color="orange" key={`rule-${rule?.id}-in-litigation`}>
                  In Litigation
                </Tag>
              ),
              judgment: (
                <Tag color="yellow" key={`rule-${rule?.id}-judgment`}>
                  Judgment
                </Tag>
              ),
              has_legal_payment_method: (
                <Tag color="blue" key={`rule-${rule?.id}-has-legal-payment-method`}>
                  Legal Payment Methods
                </Tag>
              ),
              has_legal_forwarding_entity: (
                <Tag color="purple" key={`rule-${rule?.id}-has-legal-forwarding-entity`}>
                  Legal Forwarding Entity
                </Tag>
              ),
            }[status]),
        ) ?? "-",
    },
    {
      title: "Product",
      dataIndex: "productOfferingId",
      key: "productOfferingId",
      render: (index, rule) => productOfferingsById[rule.productOfferingId]?.name,
    },
    {
      title: "Account Balance",
      children: [
        {
          title: "From",
          dataIndex: "minAccountBalance",
          key: "minAccountBalance",
        },
        {
          title: "To",
          dataIndex: "maxAccountBalance",
          key: "maxAccountBalance",
        },
      ],
      key: "dollarAmount",
    },
    {
      title: "Days in Aktos",
      children: [
        {
          title: "From",
          dataIndex: "minAccountAgeDays",
          key: "minAccountAgeDays",
        },
        {
          title: "To",
          dataIndex: "maxAccountAgeDays",
          key: "maxAccountAgeDays",
        },
      ],
      key: "daysInAktos",
    },
    {
      title: "Days Since Upload",
      children: [
        {
          title: "From",
          dataIndex: "minAccountUploadAgeDays",
          key: "minAccountUploadAgeDays",
          render: (index, rule) => rule?.minAccountUploadAgeDays ?? "-",
        },
        {
          title: "To",
          dataIndex: "maxAccountUploadAgeDays",
          key: "maxAccountUploadAgeDays",
          render: (index, rule) => rule?.maxAccountUploadAgeDays ?? "-",
        },
      ],
      key: "daysSinceUpload",
    },
    {
      title: "Turnover Date",
      children: [
        {
          title: "From",
          dataIndex: "minTurnoverDate",
          key: "minTurnoverDate",
        },
        {
          title: "To",
          dataIndex: "maxTurnoverDate",
          key: "maxTurnoverDate",
        },
      ],
      key: "turnoverDate",
    },
    {
      title: "Days Since Turnover",
      children: [
        {
          title: "From",
          dataIndex: "minTurnoverAgeDays",
          key: "minTurnoverAgeDays",
        },
        {
          title: "To",
          dataIndex: "maxTurnoverAgeDays",
          key: "maxTurnoverAgeDays",
        },
      ],
      key: "daysSinceTurnover",
    },
  ];
  return <Table bordered columns={columns} dataSource={populateKey(rules)} pagination={false} />;
}
